module.exports = __webpack_public_path__ + "img/img_04.2ead9aee.webp";